import {
  bindHover,
  bindMenu,
  usePopupState,
} from 'material-ui-popup-state/hooks';

import { KeyboardArrowDown } from '@mui/icons-material';

import {
  ButtonDropdown,
  DropdownItem,
  DropdownItemLink,
  DropdownMenu,
} from '../Navbar.styles';

const DashboardMenu = () => {
  const dashboardMenuState = usePopupState({ variant: 'popover' });

  const dashboardMenuItems = [
    {
      label: 'Dashboard',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/dashboard/management-panel`,
    },
    {
      label: 'Edição de Arquivos Fiscais',
      link: ``,
    },
  ];

  return (
    <>
      <ButtonDropdown
        {...bindHover(dashboardMenuState)}
        endIcon={<KeyboardArrowDown />}
        data-testid="dashboard-menu"
      >
        Dashboard
      </ButtonDropdown>
      <DropdownMenu {...bindMenu(dashboardMenuState)}>
        {dashboardMenuItems.map((item) => (
          <DropdownItemLink href={item.link} key={item.label}>
            <DropdownItem>{item.label}</DropdownItem>
          </DropdownItemLink>
        ))}
      </DropdownMenu>
    </>
  );
};

export default DashboardMenu;
